var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Recipe',{attrs:{"recipe":_vm.recipe,"buttonLoading":_vm.buttonLoading},on:{"saveRecipe":_vm.saveRecipe}})}
var staticRenderFns = []

export { render, staticRenderFns }